import { render, staticRenderFns } from "./RelatorioInventarioFlorestal.vue?vue&type=template&id=224e1e8e&scoped=true"
import script from "./RelatorioInventarioFlorestal.vue?vue&type=script&lang=js"
export * from "./RelatorioInventarioFlorestal.vue?vue&type=script&lang=js"
import style0 from "./RelatorioInventarioFlorestal.vue?vue&type=style&index=0&id=224e1e8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224e1e8e",
  null
  
)

export default component.exports